import { CloudDownload, CloudUpload } from "@material-ui/icons";
import * as FileSaver from "file-saver";
import React from "react";
import { Button, CreateButton, ExportButton, TopToolbar } from "react-admin";
import { useAppDataProvider } from "../../../dataprovider";
import * as XLSX from "xlsx";
import moment from "moment";

export const ListActions = props => {
  const { notify, customers } = props;
  const dataProvider = useAppDataProvider();
  const getAcByAcReg = async acReg => {
    var result = await dataProvider.getList(`cdmaircraft`, {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "ASC" },
      filter: { acReg__eq: acReg },
    });
    return result?.data ?? [];
  };
  const ExportTemplateClickButton = () => {
    const newValues = [
      {
        MaintenanceType: "The value 1 or 2 must be entered. 1 for REDELIVER, 2 for C Check. Exp: 1 ",
        CustomerCode: "Customer code must be entered in this column. Exp: THY-C",
        Ac: "Aircraft Registration Code must be entered in this column. Exp: TC-KNN",
        ScheduledStartDate: "Scheduled Start Date must be entered in this column. Exp: 20/10/2023",
        ScheduledFinishDate: "Scheduled Finish Date must be entered in this column. Exp: 20/10/2023",
        RealStartDate: "Real Start Date must be entered in this column. Exp: 20/10/2023",
        RealFinishDate: "Real Finish Date must be entered in this column. Exp: 20/10/2023",
        Remark: "Remark must be entered in this column. Exp: Remark Test",
      },
    ];
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "Aircraft Under Maintenance Import Template";

    const ws = XLSX.utils.json_to_sheet(newValues);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(excelData, fileName + fileExtension);
  };

  const ImportClickButton = () => {
    document.getElementById("fileInput")?.click();
  };

  const fileChange = async e => {
    try {
      let file: File = e.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = async e => {
        let arrayBuffer: any = fileReader.result;
        var data = new Uint8Array(arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i) {
          arr[i] = String.fromCharCode(data[i]);
        }
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
        var sheetName = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[sheetName];
        var dataList = XLSX.utils.sheet_to_json(worksheet, { raw: false });

        dataList = await Promise.all(
          (dataList = dataList
            .filter(
              (x: any) => x.CustomerCode && x.MaintenanceType && x.Ac && x.ScheduledStartDate && x.ScheduledFinishDate
            )
            .map(async (x: any): Promise<any[]> => {
              x.CustomerId = customers.find(k => k.customerCode == x.CustomerCode)?.id ?? 0;
              x.AcId = (await getAcByAcReg(x.Ac))?.[0]?.id;
              x.ScheduledStartDate = moment.utc(x.ScheduledStartDate).local();
              x.ScheduledFinishDate = moment.utc(x.ScheduledFinishDate).local();
              x.RealStartDate = x.RealStartDate ? moment.utc(x.RealStartDate).local() : null;
              x.RealFinishDate = x.RealFinishDate ? moment.utc(x.RealFinishDate).local() : null;
              return x;
            }))
        );

        BulkExcel(dataList);
      };
    } catch (error) {
      notify(`Failed: ${error}`, "error");
    }
  };
  const BulkExcel = (data: any[]) => {
    dataProvider
      .postBulkAircraftUnderMaintenances(data)
      .then(response => {
        if (response?.data?.length > 0) {
          let errorMessages = response?.data?.join?.("\r\n");
          notify(errorMessages, "warning", false, false, 5000, true);
        } else {
          notify(`Records created`, "success", false, false);
        }
      })
      .catch(response => {
        notify(`${response}`, "error", false, false);
      })
      .finally(() => {});
  };
  return (
    <TopToolbar {...props} style={{ minWidth: 500 }}>
      <input
        hidden
        id="fileInput"
        type="file"
        accept=".csv,.xlsv,.xlsx,.msg,application/vnd.ms-outlook.msg"
        onChange={e => fileChange(e)}
      ></input>
      <CreateButton basePath={props.basePath} icon={props.icon} label={props.label} />
      <ExportButton
        resource={props.resource}
        sort={props.currentSort}
        filterValues={props.filterValues}
        maxResults={10000}
      />
      <Button onClick={ExportTemplateClickButton} label="Export Template">
        <CloudDownload />
      </Button>
      <Button onClick={ImportClickButton} label="Import Excel">
        <CloudUpload />
      </Button>
    </TopToolbar>
  );
};
export default ListActions;
